// Linear Current Density units with conversion factors to ampere per meter (A/m)
export const linearCurrentDensityUnits = [
  { id: 'ampere-per-meter', name: 'Ampere per Meter', symbol: 'A/m', plural: 'Amperes per Meter', factor: 1 },
  { id: 'ampere-per-centimeter', name: 'Ampere per Centimeter', symbol: 'A/cm', plural: 'Amperes per Centimeter', factor: 100 },
  { id: 'ampere-per-millimeter', name: 'Ampere per Millimeter', symbol: 'A/mm', plural: 'Amperes per Millimeter', factor: 1000 },
  { id: 'ampere-per-inch', name: 'Ampere per Inch', symbol: 'A/in', plural: 'Amperes per Inch', factor: 39.3700787402 },
  { id: 'milliampere-per-meter', name: 'Milliampere per Meter', symbol: 'mA/m', plural: 'Milliamperes per Meter', factor: 0.001 },
  { id: 'milliampere-per-centimeter', name: 'Milliampere per Centimeter', symbol: 'mA/cm', plural: 'Milliamperes per Centimeter', factor: 0.1 },
  { id: 'kiloampere-per-meter', name: 'Kiloampere per Meter', symbol: 'kA/m', plural: 'Kiloamperes per Meter', factor: 1000 },
  { id: 'abampere-per-meter', name: 'Abampere per Meter', symbol: 'abA/m', plural: 'Abamperes per Meter', factor: 10 },
  { id: 'abampere-per-centimeter', name: 'Abampere per Centimeter', symbol: 'abA/cm', plural: 'Abamperes per Centimeter', factor: 1000 },
];

export const popularLinearCurrentDensityConversions = [
  { from: 'ampere-per-meter', to: 'ampere-per-centimeter' },
  { from: 'ampere-per-centimeter', to: 'ampere-per-meter' },
  { from: 'ampere-per-meter', to: 'ampere-per-millimeter' },
  { from: 'ampere-per-millimeter', to: 'ampere-per-meter' },
  { from: 'ampere-per-meter', to: 'ampere-per-inch' },
  { from: 'ampere-per-inch', to: 'ampere-per-meter' },
  { from: 'ampere-per-meter', to: 'milliampere-per-meter' },
  { from: 'milliampere-per-meter', to: 'ampere-per-meter' },
  { from: 'ampere-per-centimeter', to: 'ampere-per-millimeter' },
  { from: 'ampere-per-millimeter', to: 'ampere-per-centimeter' },
  { from: 'kiloampere-per-meter', to: 'ampere-per-meter' },
  { from: 'ampere-per-meter', to: 'kiloampere-per-meter' },
  { from: 'milliampere-per-centimeter', to: 'ampere-per-centimeter' },
  { from: 'ampere-per-centimeter', to: 'milliampere-per-centimeter' },
  { from: 'abampere-per-meter', to: 'ampere-per-meter' },
  { from: 'ampere-per-meter', to: 'abampere-per-meter' },
  { from: 'abampere-per-centimeter', to: 'ampere-per-centimeter' },
  { from: 'ampere-per-centimeter', to: 'abampere-per-centimeter' },
];

export const getUnitById = (id) => linearCurrentDensityUnits.find(unit => unit.id === id);

export const convertLinearCurrentDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert linear current density units and learn the conversion formula.`;
};
